import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenerateFormService, PerForm } from '@lbmx/per-form';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { schemaDefinition } from './add-edit-exclusion.ui';

export interface UserExcludeOptions {
  excludeOption?: [];
}

export interface ExcludeOptionsForm {
  fields: object;
  errorCode?: number;
}

export interface SelectedExcludeOptions {
  record?: {
    ExcludeOption?: number;
  };
  errorCode?: number;
}

@Component({
  selector: 'lib-add-edit-exclusion-container',
  template: ` <lib-add-edit-exclusion
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-add-edit-exclusion>`,
  styles: ['body .ui-dialog .ui-dialog-content { overflow-auto; }']
})
export class AddEditExclusionContainerComponent implements OnInit {
  @Input() public baseUrl: string;
  @Input() public exclusionOption: number;
  @Input() public selection: any;
  @Output() public closeDialog = new EventEmitter();
  @Output() public updateExcludeOptions = new EventEmitter();

  public form: PerForm;
  public schemaDefinition = schemaDefinition;
  constructor(
    private http: BaseHttpService,
    private spinner: SpinnerService,
    private translocoService: TranslocoService,
    private toast: ToastrNotificationService,
    private formGenerator: GenerateFormService
  ) {}

  public ngOnInit(): void {
    if (this.exclusionOption === 1){
      const selectedKeys = [...this.selection].map(
        ({ productExclusionKey, ..._ }) => productExclusionKey
      );

      this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}` + '/edit',
        httpMethod: 'POST',
        body: {
          ProductExclusionKey: selectedKeys[0]
        }
      })
      .pipe(
        tap(({ fields }: any) => {
          this.form = this.formGenerator.init(
            this.schemaDefinition(fields),
          );
        }),
        catchError(() =>
          of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          )
        )
      )
      .subscribe();
    }
    else{
      this.http
        .fetchWithFqn({
          endpoint: `${this.baseUrl}` + '/exclude-options/form',
          httpMethod: 'GET',
        })
        .pipe(
          tap(({ fields }: any) => {
            this.form = this.formGenerator.init(
              this.schemaDefinition(fields),
            );
          }),
          catchError(() =>
            of(
              this.toast.errorNotify(
                this.translocoService.translate('MESSAGES.GENERIC_ERROR')
              )
            )
          )
        )
        .subscribe();
    }
  }

  public save(formValues: any) {
    this.spinner.on();
    if (this.exclusionOption === 1){
      const selectedKeys = [...this.selection].map(
        ({ productExclusionKey, ..._ }) => productExclusionKey
      );
      this.http
        .fetchWithFqn({
          endpoint: `${this.baseUrl}/submit`,
          httpMethod: 'POST',
          body: {...formValues, ProductExclusionKey: selectedKeys[0]},
        })
        .pipe(
          tap((response: any) => {
            this.toast.successNotify(
              this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
            );
            this.closeDialog.emit();
            this.updateExcludeOptions.emit();
          }),
          catchError((error: any) => {
          if (error?.error?.errorCode === 'AlreadyExist') {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('ANALYTICS_EXCLUSION.DUPLICATED_DATA')
              )
            );
          } else {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('MESSAGES.GENERIC_ERROR')
              )
            );
          }
        }),
        finalize(() => this.spinner.off())
      )
        .subscribe();
    }
    else{
      this.http
        .fetchWithFqn({
          endpoint: `${this.baseUrl}/exclude-options`,
          httpMethod: 'POST',
          body: formValues,
        })
        .pipe(
          tap((response: any) => {
            this.toast.successNotify(
              this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
            );
            this.closeDialog.emit();
            this.updateExcludeOptions.emit();
          }),
          catchError((error: any) => {
          if (error?.error?.errorCode === 'AlreadyExist') {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('ANALYTICS_EXCLUSION.DUPLICATED_DATA')
              )
            );
          } else {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('MESSAGES.GENERIC_ERROR')
              )
            );
          }
        }),
        finalize(() => this.spinner.off())
      )
        .subscribe();
    }
  }
}
